export default __webpack_public_path__ + "static/media/thsarabunnew_bolditalic-webfont.bc67f412.eot";